import { useRouter } from 'vue-router';
import { useErrorStore } from '@/stores/components/errorStore';

export default function useErrorRedirect(router) {
  const resolvedRouter = router ?? useRouter();
  const errorStore = useErrorStore();

  const redirectToErrorPage = ({
    code = '', message = '', traceId = null, returnUrl = null,
  } = {}) => {
    errorStore.setError({
      code, message, traceId, returnUrl,
    });
    return resolvedRouter.push({
      name: 'error',
      params: { errorCode: code || undefined },
    });
  };

  return { redirectToErrorPage };
}
